export default __webpack_public_path__ + "images/a5608fb5ab1329831a2c52a3b7f819ad.png";